import { motion } from 'framer-motion';

export interface FilterOption {
  value: string;
  label: string;
  count: number;
  // Tailwind classes for the chip's own color identity
  colorClass: string;   // bg + text (inactive base)
  activeClass: string;  // bg + text (active state — richer)
  borderClass: string;  // border color when active
  ringClass: string;    // ring color when active
}

interface FilterCardProps {
  options: FilterOption[];
  selected: string[];   // empty = All active
  onToggle: (value: string) => void;
  onClearAll: () => void;
}

export function FilterCard({ options, selected, onToggle, onClearAll }: FilterCardProps) {
  const isAllActive = selected.length === 0;

  return (
    <div className="flex items-center gap-2 flex-wrap">
      {/* All chip */}
      <motion.button
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        onClick={onClearAll}
        className={`flex flex-col items-start justify-between p-3 rounded-xl min-w-[72px] h-[62px] transition-all border ${
          isAllActive
            ? 'bg-gray-800 dark:bg-white text-white dark:text-gray-900 border-gray-700 dark:border-white shadow-md ring-1 ring-gray-400 dark:ring-white ring-offset-1 ring-offset-gray-50 dark:ring-offset-bg-deep'
            : 'bg-gray-100 dark:bg-white/5 text-gray-500 dark:text-gray-400 border-transparent opacity-70 hover:opacity-100'
        }`}
      >
        <span className="text-micro font-bold uppercase tracking-widest leading-none">All</span>
        <span className="text-title font-bold font-display leading-none">
          {options.reduce((sum, o) => sum + o.count, 0)}
        </span>
      </motion.button>

      {/* Status chips */}
      {options.map((opt) => {
        const isActive = selected.includes(opt.value);
        return (
          <motion.button
            key={opt.value}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => onToggle(opt.value)}
            className={`flex flex-col items-start justify-between p-3 rounded-xl min-w-[72px] h-[62px] transition-all border ${
              isActive
                ? `${opt.activeClass} ${opt.borderClass} shadow-md ring-1 ${opt.ringClass} ring-offset-1 ring-offset-gray-50 dark:ring-offset-bg-deep`
                : `${opt.colorClass} border-transparent opacity-70 hover:opacity-100`
            }`}
          >
            <span className="text-micro font-bold uppercase tracking-widest leading-none">
              {opt.label}
            </span>
            <span className="text-title font-bold font-display leading-none">
              {opt.count}
            </span>
          </motion.button>
        );
      })}
    </div>
  );
}
